module.exports = __webpack_public_path__ + "static/media/male__old.20bb1f1c.svg";